import { Card, CardContent, Tooltip } from "@material-ui/core";
import React, { Component } from "react";
import { TabsPengaturanKomitmentMutu } from "./components/TabsPengaturanKomitmentMutu";
class StandarSpmi extends Component {
    
    render(){
        
        return(
            <>
                <TabsPengaturanKomitmentMutu idSp={this.props.id_sp}/>
            </>
        )
    }
}
export default StandarSpmi;